import { IAppState } from '../../redux';

export function selectOfferId(state: IAppState): number | null {
  const {
    offer: { id },
  } = state;

  return id || null;
}
